import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import style from './styles/style.module.css';

class TagItem extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { title, targetLink, deleteHandler, contentStyle } = this.props;
        const content = (
            <span className={ style.itemContent } style={ contentStyle }>{ title }</span>
        );
        if( targetLink ) {
            return (
                <Link
                to={ targetLink }
                className={ style.tagItem }
                style={ this.props.style }
                data-white={ this.props.white } >
                    { content }
                </Link>
            );
        }
        return (
            <div className={ style.tagItem }
            style={ this.props.style }
            data-white={ this.props.white } >
                { content }
                { deleteHandler &&
                    <FontAwesomeIcon icon={ faTimesCircle } aria-hidden="true"
                    title="Remove Tag" onClick={ deleteHandler }
                    style={ this.props.white ? { color: 'white' } : {} }/>
                }
            </div>
        );
    }
}
TagItem.defaultProps = {
    title: 'BLANK',
    deleteHandler: null,
};


export default TagItem;
